/* src/app/components/enter-foodspot-code-modal/enter-foodspot-code-modal.component.scss */
.wrapper-foodspot {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
}
.wrapper-foodspot .left {
  width: 35%;
  background: #F3F3F3;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 10px 10px 10px 15px;
}
.wrapper-foodspot .left h3 {
  font-size: 17px;
  line-height: 24px;
}
.wrapper-foodspot .left p {
  margin: 20px 0px;
  line-height: 22px;
}
.wrapper-foodspot .left a {
  text-decoration: none;
  font-weight: bold;
}
.wrapper-foodspot .right {
  width: 65%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.wrapper-foodspot .right .header-section {
  padding: 20px 0px;
  text-align: center;
  position: relative;
}
.wrapper-foodspot .right .header-section ion-icon {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.wrapper-foodspot .right .header-section {
  border-bottom: 1px solid rgb(243, 243, 243);
}
.wrapper-foodspot .right .input-section {
  width: 100%;
  padding: 20px;
}
.wrapper-foodspot .right .input-section p {
  margin: 20px 0px;
  line-height: 22px;
}
.wrapper-foodspot .right .input-section .input-block {
  display: flex;
  align-items: flex-start;
}
.wrapper-foodspot .right .input-section .input-block ion-input {
  border: 1px solid rgb(243, 243, 243);
  --border: 1px solid rgba(243, 243, 243, 1);
  transition: all ease-in-out 1s;
  border-radius: 20px;
  margin-right: 10px;
  padding: 20px;
  --padding-end: 10px;
  --padding-start: 20px;
  --highlight-color-focused: transparent;
  --border-color: transparent;
  --box-shadow: none;
  cursor: text;
}
.wrapper-foodspot .right .input-section .input-block ion-input.error {
  border: 1px solid red;
}
.wrapper-foodspot .right .input-section .input-block ion-button {
  text-transform: capitalize;
}
.error-message span {
  color: red;
  font-size: 12px;
  padding-left: 5px;
}
ion-input.no-underline {
  --border-color: transparent;
  --box-shadow: none;
}
/*# sourceMappingURL=enter-foodspot-code-modal.component.css.map */
